module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "entity": _vm.mappedInput,
      "fields": _vm.fields,
      "model": "inputs",
      "cancel": false
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30d00d8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/input/InputForm.vue
// module id = 982
// module chunks = 2